import { Injectable } from '@angular/core';
import { DatosConfiguracionAplicacionService } from './datos-configuracion-aplicacion.service';

@Injectable({
  providedIn: 'root'
})
export class ValidacionesFormularioRltService {

  mensajeErrorDosier: string = '';
  mensajeErrorPeriodicidad: string = '';
  mensajeErrorDiaEnvio: string = '';
  mensajeErrorHoraEnvio: string = '';
  mensajeErrorCadaDia: string = '';
  mensajeErrorFrecuenciaMensual: string = '';
  mensajeErrorDiaMes: string = '';
  mensajeErrorTipoDia: string = '';

  constructor(private datosConfiguracionAplicacionService: DatosConfiguracionAplicacionService) { }

  getForm(tipo: string) {
    return this.datosConfiguracionAplicacionService.getFormByTipo(tipo);
  }
  getControl(campo: string, tipo: string) {
    return this.getForm(tipo).get(campo);
  }

  isCampoValidoRlt(campo:string, tipo:string){
    const control = this.getControl(campo, tipo);
    if (!control) return false;

    switch (campo) {
      case 'periodicidad':
        if(control.errors?.required){
          this.mensajeErrorPeriodicidad = 'La periodicidad es requerida  si la configuración de Rlt está activa.'
        }
        break;
      case 'cadaDia':
        if(control.errors?.min){
          this.mensajeErrorCadaDia = 'Como mínimo debe ser cada 1 día.'
        }
        break;
      case 'horaEnvio':
        if(control.errors?.required){
          this.mensajeErrorHoraEnvio = 'La hora de envío es requerida.'
        }
        break;
      case 'diaEnvio':
        if(control.errors?.required){
          this.mensajeErrorDiaEnvio = 'El día de la semana es requerido.'
        }
        break;
      case 'frecuenciaMensual':
        if(control.errors?.required){
          this.mensajeErrorFrecuenciaMensual = 'Se debe seleccionar una de las siguientes dos opciones.'
        }
        break;
      case 'diaMes':
        if(control.errors?.required || control.errors?.min){
          this.mensajeErrorDiaMes = 'El día del mes es requerido y debe ser mayor a 0.'
        }
        break;
      case 'tipoDia':
        if(control.errors?.required){
          this.mensajeErrorTipoDia = 'El tipo de día es requerido.'
        }
        break;
    }
    // if(this.datosConfiguracionAplicacionService.configuracionRltForm.controls[campo]){
    //     return this.datosConfiguracionAplicacionService.configuracionRltForm.controls[campo].errors && this.datosConfiguracionAplicacionService.configuracionRltForm.controls[campo].touched;
    //   }else{
    //     return true;
    //   }
    return control.errors && control.touched;
  }

}
